import React, { useEffect } from 'react'
import { TextField, MenuItem } from '@mui/material'
import { useTypeOperation } from '../../hooks/useTypeOperation'
import { TypeOperation } from '../../interfaces/TypeOperation/TypeOperation'

interface TypeOperationDDLProps {
  onChange: any
  value: any
  type?: 'outlined' | 'filled' | 'standard' | undefined
  defaultLabel?: string
  isSearching?: boolean
  fullWidth?: boolean
  error?: boolean
  allowedIds?: number[]
  disabled?: boolean
  errorText?: string
}

export const TypeOperationDLL: React.FC<TypeOperationDDLProps> = ({
  onChange,
  value,
  type,
  fullWidth = false,
  error = false,
  defaultLabel,
  allowedIds,
  disabled = false,
  errorText = 'Debe seleccionar un tipo de Operación'
}) => {
  const {
    typeOperationState: { typeOperation },
    getTypeOperation
  } = useTypeOperation()

  useEffect(() => {
    if (typeOperation?.length === 0) {
      getTypeOperation()
    }
  }, [])

  const arrTypeOperation =
    typeOperation !== undefined
      ? typeOperation
          .filter((option: TypeOperation) =>
            allowedIds ? allowedIds.includes(option.typeOperationId) : true
          )
          .map((option: TypeOperation) => (
            <MenuItem
              key={option.typeOperationId}
              value={option.typeOperationId}
            >
              {option.name}
            </MenuItem>
          ))
      : []

  return (
    <TextField
      variant={type}
      id='typeOperationId'
      name='typeOperationId'
      label={defaultLabel}
      select
      value={value}
      disabled={disabled}
      onChange={onChange}
      fullWidth={fullWidth}
      error={error}
      helperText={error ? errorText : undefined}
    >
      <MenuItem key={0} value={0}>
        {'Seleccionar Tipo de Operación...'}
      </MenuItem>
      {arrTypeOperation}
    </TextField>
  )
}
